export function getClockTime(date: Date, utc = false): string {
  const hours = utc ? date.getUTCHours() : date.getHours();
  const minutes = utc ? date.getUTCMinutes() : date.getMinutes();
  const seconds = utc ? date.getUTCSeconds() : date.getSeconds();
  const minSec = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

  return hours ? `T${hours.toString().padStart(2, '0')}:${minSec}` : `T${minSec}`;
}
